import * as React from "react";
import { IProject } from "../../reducers/project";
import styled from "styled-components";
import { projectLabel } from "../Project/ProjectExpander";
import content from "../../content";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { useState } from "react";

const Header = styled.div`
  padding: 16px 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;

  letter-spacing: -0.01em;

  color: #1e2029;
  border-bottom: 1px solid #e1e0e0;
`;

const Grid = styled.div<{ desktop?: boolean }>`
  padding: 0px 16px;
  display: grid;
  grid-template-columns: ${({ desktop }) => (desktop ? "1fr" : "30vw")} ${({
                                                                             desktop,
                                                                           }) => (desktop ? "auto" : "100px")};
  font-size: ${({ desktop }) => (desktop ? "14" : "12")}px;
`;

export function SummaryExpander({
                                    project,
                                    expanded,
                                    setExpanded,
                                }: ISummaryExpander) {
    const toggleOpen = () => {
        setExpanded(expanded ? false : project.id);
    };

    return (
        <div style={{ padding: "0px 20px" }}>
            <Header onClick={toggleOpen} style={{ cursor: "pointer" }}>
                <div>{projectLabel(project)}</div>
                <div>
                    {expanded ? (
                        <KeyboardArrowDown
                            style={{
                                fontSize: "18px",
                                color: "black",
                                zIndex: 1,
                            }}
                        />
                    ) : (
                        <KeyboardArrowUp
                            style={{
                                fontSize: "18px",
                                color: "black",
                                zIndex: 1,
                            }}
                        />
                    )}
                </div>
            </Header>
            {expanded && (
                <Grid desktop={true} style={{ margin: "25px 0px" }}>
                    {project.components.map((s) => (
                        <>
                            <div
                                style={{
                                    padding: "4px 0px",
                                    fontFamily: "Inter",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    color: "#7A7C8B",
                                    letterSpacing: "-0.01em",
                                    fontSize: "12px",
                                    lineHeight: "12px",
                                }}
                            >
                                {content.getValue(s?.name)}
                            </div>
                            <div
                                style={{
                                    padding: "4px 0px",
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    letterSpacing: "-0.01em",
                                    color: "#1B576A",
                                    lineHeight: "12px",
                                }}
                            >
                                {s?.price} {content.getValue("currency")}
                            </div>
                        </>
                    ))}
                </Grid>
            )}
        </div>
    );
}

export interface ISummaryExpander {
    project: IProject;
    expanded?: boolean;
    setExpanded?: any;
}
